import {
  consentSnapshot,
  type ConsentDecision,
} from '../utils/consent/consentGate'
import { refreshCookieExpiry } from '../utils/storage/utils'

// The EU, EEA and UK, as listed by @redbrickmedia/duplex.user-identity for its
// gdpr policy. The package does not export the list, so keep the two in step.
const GDPR_COUNTRIES = new Set([
  'AT',
  'BE',
  'BG',
  'HR',
  'CY',
  'CZ',
  'DK',
  'EE',
  'FI',
  'FR',
  'DE',
  'GR',
  'HU',
  'IE',
  'IT',
  'LV',
  'LT',
  'LU',
  'MT',
  'NL',
  'PL',
  'PT',
  'RO',
  'SK',
  'SI',
  'ES',
  'SE',
  'IS',
  'LI',
  'NO',
  'GB',
])

/**
 * EU and UK guidance caps a tracking cookie at 13 months and does not let a
 * visit extend it, so the expiry only slides for a visitor known to be
 * outside them. Decided on the geo country, which every load has, rather than
 * the CMP, which never answers when it is blocked. A CMP that has already
 * said GDPR applies still wins.
 */
export function mayExtendCookieLifetime(
  country: string | null | undefined,
  decision: Pick<ConsentDecision, 'policy' | 'policies'> | null
): boolean {
  if (decision && [decision.policy, ...decision.policies].includes('gdpr')) {
    return false
  }
  return Boolean(country) && !GDPR_COUNTRIES.has(String(country).toUpperCase())
}

/**
 * Rewrites the named cookies with a fresh max-age, so a visitor who keeps
 * coming back keeps the same key and cohort instead of losing them a fixed
 * time after the first visit.
 */
export function refreshIdentityCookies(
  names: string[],
  maxAge: number,
  country: string | null | undefined
): void {
  if (!mayExtendCookieLifetime(country, consentSnapshot())) return
  names.forEach((name) => refreshCookieExpiry(name, maxAge))
}
